// extracted by mini-css-extract-plugin
module.exports = {"PannableContainer":"PannableContainer_PannableContainer__BbQ52","inner":"PannableContainer_inner__Yy9mv","contentContainer":"PannableContainer_contentContainer__8D4Nj"};